import { api_url } from "./website";

export const AUTH_LOGIN_URL = api_url + "user/login";
export const AUTH_REGISTER_URL = api_url + "user/register";
export const AUTH_RESET_URL = api_url + "user/forget-password";
export const CREATE_API_URL = api_url + "analytics/apps/create";

export const ANALYTICS_CUSTOMER_URL = api_url + "analytics/customer";
export const ANALYTICS_INTENT_URL = api_url + "analytics/intent";
export const ANALYTICS_APP_LIST_URL = api_url + "analytics/apps/list";
export const ANALYTICS_UTTERANCES_URL = api_url + "analytics/utterance";
export const ANALYTICS_SUMMARY_URL = api_url + "analytics/summary";
export const ANALYTICS_MESSAGE_URL = api_url + "analytics/msg/last-hour";
export const ANALYTICS_CONVERSATIONAL_PATH_URL =
  api_url + "analytics/conversation-path";
export const ANALYTICS_SKILL_ACTIVATION_URL =
  api_url + "analytics/skill-activation/list";
export const ANALYTICS_APP_DELETE_URL = api_url + "analytics/apps/delete";
